module.exports = __webpack_public_path__ + "static/media/OMC-ITALY.b6492f6a.png";